import {
  APPROVAL_FACILITY_HOLIDAY,
  APPROVAL_FACILITY_HOLIDAY_SUCCESS,
  APPROVAL_FACILITY_HOLIDAY_ERROR,
  APPROVAL_FACILITY_HOLIDAY_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApprovalFacilityHoliday = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_FACILITY_HOLIDAY:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_FACILITY_HOLIDAY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_FACILITY_HOLIDAY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVAL_FACILITY_HOLIDAY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApprovalFacilityHoliday;
